import {
    GameLoaderController,
    TranslationLoader,
} from '@nackle/arcade-core-v2';
import { DeckWrapper } from './components/DeckWrapper';
import React from 'react';
import { Provider } from 'react-redux';
import { appStore } from './app-store';
import './app.less';
import ArcadeIndex from './arcade-index/ArcadeIndex';
import { IMG_AWARD_SWIRL, LOADER_URL } from './assets';
import Auth from './auth';
import { ProjectKeys } from './translation-data';
import { SourceTracker } from './utils/sourceTracking';

const App = () => {
    return (
        <Provider store={ appStore }>
            <Auth>
                <SourceTracker />
                <DeckWrapper>
                    <div className='arcade-webapp'>
                    <ArcadeIndex />
                    <TranslationLoader
                        projectKeys={ [
                            ProjectKeys.ARCADE_UI,
                        ] }
                    />
                    <GameLoaderController
                        imageUrls={ { IMG_AWARD_SWIRL } }
                        loaderUrl={ LOADER_URL }
                    />
                    </div>
                </DeckWrapper>
            </Auth>
        </Provider>
    );
};

export default App;
